import { graphql, useStaticQuery } from "gatsby";
import { InferProps } from "prop-types";
import { Link } from "gatsby-theme-material-ui";
import React, { ReactElement } from "react";
import { Typography } from "@material-ui/core";
import { createStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import useSiteMetadata from "../SiteMetadata";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "space-around",
      textAlign: "center",
      // marginTop: theme.spacing(2),
      "& > span": {
        display: "none",
      },
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    address: {
      display: "flex",
      flexDirection: "column",
      textAlign: "center",
      "& > span:not(:last-child)": {
        "&:after": {
          content: "','",
          display: "inline-block",
          marginRight: theme.spacing(1),
        },
      },
    },
  })
);

export const LocalBusiness = ({
  headingComponent = "h1",
  headingVariant = "h5",
  addressTitle = "Address",
  emailTitle = "Email",
  telephoneTitle = "Telephone",
}: InferProps<typeof LocalBusiness.propTypes> = {}): ReactElement => {
  const classes = useStyles();
  const theme = useTheme();

  const { description, email, map, telephone } = useSiteMetadata();

  const data = useStaticQuery(graphql`
    query LocalBusiness {
      allPlaceDetails(filter: { id: { ne: "dummy" } }) {
        edges {
          node {
            id
          }
        }
      }
    }
  `);

  const { result: placeDetails } = data?.allPlaceDetails?.edges[0]?.node;

  return (
    <section
      itemScope
      itemType="http://schema.org/LocalBusiness"
      className={classes.root}
    >
      <span itemProp="name">{placeDetails?.name}</span>
      <span itemProp="description">{description}</span>
      {placeDetails && (
        <div>
          {addressTitle && (
            <Typography
              // style={{ marginTop: theme.spacing(2) }}
              component={headingComponent}
              variant={headingVariant}
            >
              {addressTitle}
            </Typography>
          )}

          <Link href={map.url}>
            <address
              className={classes.address}
              itemProp="address"
              itemScope
              itemType="http://schema.org/PostalAddress"
            >
              <span itemProp="streetAddress">
                {`${
                  placeDetails?.address_components?.find((component) =>
                    component.types.includes("street_number")
                  ).long_name
                  }
                ${
                  placeDetails?.address_components?.find((component) =>
                    component.types.includes("route")
                  ).long_name
                  }`}
              </span>

              <span itemProp="addressRegion">
                {
                  placeDetails?.address_components?.find((component) =>
                    component.types.includes("postal_town")
                  ).long_name
                }
              </span>
              <span itemProp="postalCode">
                {
                  placeDetails?.address_components?.find((component) =>
                    component.types.includes("postal_code")
                  ).long_name
                }
              </span>
            </address>
          </Link>
        </div>
      )}
      <div>
        {emailTitle && (
          <Typography
            style={{ marginTop: theme.spacing(2) }}
            component={headingComponent}
            variant={headingVariant}
          >
            {emailTitle}
          </Typography>
        )}
        <Link itemProp="email" href={`mailto:${email}`}>
          {email}
        </Link>
      </div>
      <div>
        {telephoneTitle && (
          <Typography
            style={{ marginTop: theme.spacing(2) }}
            component={headingComponent}
            variant={headingVariant}
          >
            {telephoneTitle}
          </Typography>
        )}
        <Link itemProp="telephone" href={`tel: ${telephone.href}`}>
          {telephone.display}
        </Link>
      </div>
    </section>
  );
};

export default LocalBusiness;


/*

 query LocalBusiness {
      allPlaceDetails(filter: { id: { ne: "dummy" } }) {
        edges {
          node {
            result {
              address_components {
                long_name
                short_name
                types
              }
              formatted_address
              geometry {
                location {
                  lat
                  lng
                }
              }
              name
            }
          }
        }
      }
    }
*/
